import React from "react";

import { DesktopDatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { useDateFormatSelect } from "store";
import toIsoMidday from "utils/to-iso-midday";

interface IProps {
  label: string;
  onChange: (value: string) => void;
  onClear: () => void;
  value: string;
  disabled?: boolean;
}

export const DatePicker: React.FC<IProps> = ({ onClear, onChange, value, label, disabled }) => {
  const dateFormat = useDateFormatSelect();
  return (
    <DesktopDatePicker
      format={dateFormat}
      views={["year", "month", "day"]}
      disabled={disabled}
      slotProps={{
        inputAdornment: { position: "start" },
        popper: {
          sx: {
            minWidth: "335px",
            ".MuiPickersCalendarHeader-labelContainer": {
              fontSize: "0.9rem"
            }
          }
        },
        textField: {
          sx: { padding: 0, svg: { color: "#0a3142" } },
          placeholder: "dd / mm / yyyy",
          fullWidth: true
        },
        field: {
          clearable: true,
          onClear
        }
      }}
      value={value ? dayjs(value) : null}
      label={label}
      onChange={(value) => {
        onChange(value ? toIsoMidday(value) : "");
      }}
    />
  );
};
